import React, { Component, PropTypes } from 'react'

/* Styles */
import './index.css'

/* Icon imports using webpack loader. Dynamic imports are not supported */
import CircleIcon from 'assets/icons/circle.svg'
import ADD from 'assets/icons/add.svg'
import CAMERA from 'assets/icons/camera.svg'
import CARET_DOWN from 'assets/icons/caret_down.svg'
import CARET_UP from 'assets/icons/caret_up.svg'
import DELETE from 'assets/icons/delete.svg'
import DUPLICATE from 'assets/icons/duplicate.svg'
import ERROR from 'assets/icons/error.svg'
import GRAPHICS_OUTPUT from 'assets/icons/graphics_output.svg'
import INFORMATION from 'assets/icons/information.svg'
import LOADING_SYNC from 'assets/icons/loading_sync.svg'
import LOGOUT from 'assets/icons/logout.svg'
import MENU from 'assets/icons/menu.svg'
import OFFLINE from 'assets/icons/offline.svg'
import ONLINE from 'assets/icons/online.svg'
import SAVE from 'assets/icons/save.svg'
import SETTINGS from 'assets/icons/settings.svg'
import SYNC from 'assets/icons/sync.svg'
import SYNC_IMPORT from 'assets/icons/sync_import.svg'
import UNDO from 'assets/icons/undo.svg'
import UPLOAD from 'assets/icons/upload.svg'
import WARNING from 'assets/icons/warning.svg'
import PROHIBITED from 'assets/icons/prohibited.svg'
import DELETETEXT from 'assets/icons/delete_text.svg'
import SCROLL_TO_TOP from 'assets/icons/scroll_to_top.svg'
import SCROLL_TO_SELECTED from 'assets/icons/scroll_to_selected.svg'
import PLAY from 'assets/icons/play.svg'
import PAUSE from 'assets/icons/pause.svg'
import SOUND from 'assets/icons/sound_mute.svg'
import SOUND_MUTE from 'assets/icons/sound.svg'
import FULLSCREEN from 'assets/icons/fullscreen.svg'
import CASH_REGISTER from 'assets/icons/cash_register.svg'
import EDGE_ANDROID_ONLINE from 'assets/icons/edge_android_online.svg'
import EDGE_ANDROID_OFFLINE from 'assets/icons/edge_android_offline.svg'
import HASHTAG from 'assets/icons/hashtag.svg'

/* Icon mapping an reexport. Did not find a better solution. */
export const ICON = {
  ADD, CAMERA, CARET_DOWN, CARET_UP, DELETE, DUPLICATE, ERROR, GRAPHICS_OUTPUT,
  INFORMATION, LOADING_SYNC, LOGOUT, MENU, OFFLINE, ONLINE, SAVE, SETTINGS,
  SYNC, SYNC_IMPORT, UNDO, UPLOAD, WARNING, PROHIBITED, DELETETEXT,
  SCROLL_TO_TOP, SCROLL_TO_SELECTED, PLAY, PAUSE, SOUND, SOUND_MUTE, FULLSCREEN,
  CASH_REGISTER, EDGE_ANDROID_ONLINE, EDGE_ANDROID_OFFLINE, HASHTAG
}

/* Supported Icon schemes. Basically just a css class name.*/
export const SCHEME = {
  DEFAULT: 'default-scheme',
  DANGER: 'danger-scheme',
  ACTION: 'action-scheme',
  WARNING: 'warning-scheme',
  READY: 'ready-scheme',
  DARK: 'dark-scheme',
  DRAGANDDROP: 'draganddrop-scheme',
  MENU: 'menu-scheme'
}

/* Icon Class. Acts as wrapper and compositing component */
export class Icon extends Component {

  getClassName() {
    const {
      className,
      scheme,
      circle,
      interactive,
      spin
    } = this.props
    let classNameArr = className ?className.split(' '):[]
    classNameArr.push('icon', 'widget')
    if (circle) classNameArr.push('circle')
    else classNameArr.push('nocircle')
    if (interactive) classNameArr.push('interactive')
    if (spin) classNameArr.push('spin')
    if (scheme) classNameArr.push(scheme)
    else classNameArr.push(SCHEME.DEFAULT)
    return classNameArr.join(' ')
  }

  renderComposed() {
    const {
      circle,
      size
    } = this.props
    if (circle) return (
      <CircleIcon className="layer" width={ size } height={ size }>
        { this.renderIcon() }
      </CircleIcon>
    )
    return this.renderIcon()
  }

  renderIcon() {
    const {
      icon,
      size,
      circle
    } = this.props
    if (!icon) return // no icon no render
    let props = {
      className: "layer"
    }
    if (!circle) {
      props.width = size
      props.height = size
    }
    return React.createElement(icon, props)
  }

  render() {
    const {
      title,
      circle,
      onClick,
    } = this.props
    return (
      <div
        className={ this.getClassName() }
        onClick={ onClick }
        title={ title }
      >
        { this.renderComposed() }
      </div>
    )
  }
}

Icon.propTypes = {
  title: PropTypes.string,
  circle: PropTypes.bool,
  icon: PropTypes.func, // should be a React Class
  title: PropTypes.string,
  onClick: PropTypes.func,
  scheme: PropTypes.string,
  size: PropTypes.number,
  interactive: PropTypes.bool,
  spin: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/app/widget/icon/index.jsx